"use strict";

customElements.define('tabbed-details', class extends HTMLElement {
  constructor() {
    super();
    this.updateAttributes = this.updateAttributes.bind(this);
    this.inputs = null;
    this.groups = new Map();
    this.labels = new Map();
  }
  connectedCallback() {
    this.inputs = this.querySelectorAll('input[type="radio"]');
    this.inputs.forEach(input => {
      const groupEl = this.querySelector(`.tabbed-details__group[data-match="${input.id}"]`);
      const labelEl = this.querySelector(`label[for="${input.id}"]`);
      if (groupEl) this.groups.set(input.id, groupEl);
      if (labelEl) {
        this.labels.set(input.id, labelEl);
        labelEl.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            labelEl.click();
          }
        }, {
          passive: false
        });
      }
      input.addEventListener('change', this.updateAttributes, {
        passive: true
      });
    });
    this.updateAttributes();
  }
  updateAttributes() {
    this.inputs.forEach(input => {
      const groupEl = this.groups.get(input.id);
      const labelEl = this.labels.get(input.id);
      if (!groupEl || !labelEl) return;
      if (input.checked) {
        groupEl.removeAttribute('inert');
        labelEl.setAttribute('aria-selected', 'true');
      } else {
        groupEl.setAttribute('inert', '');
        labelEl.setAttribute('aria-selected', 'false');
      }
    });
  }
  disconnectedCallback() {
    this.inputs?.forEach(input => {
      input.removeEventListener('change', this.updateAttributes);
      const labelEl = this.labels.get(input.id);
      if (labelEl) {
        labelEl.removeEventListener('keydown', this.handleKeyDown);
      }
    });
    this.inputs = null;
    this.groups.clear();
    this.labels.clear();
  }
});